import React from "react";
import Slider from "react-slick";
import classes from "./SliderComp.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SliderComp({
  children,
  slidesToShow = 4,
  autoplay = true,
  autoplaySpeed = 3000,
  arrows = true,
}) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay,
    autoplaySpeed,
    arrows,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: Math.min(3, slidesToShow) },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(2, slidesToShow) },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className={classes.sliderWrapper}>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
}
